import React from 'react';
import { Typography, Zoom } from '@mui/material';

const ExpiryDate = ({ label, date }) => {
  const today = new Date();
  const expiryDate = new Date(date);
  const timeDiff = expiryDate.getTime() - today.getTime();
  const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

  return (
    <Typography variant="body1">
      <strong>{label}:</strong> {expiryDate.toLocaleDateString("en-GB")}
      {daysRemaining <= 0 ? (
        <Typography
          sx={{
            color: "red",
            fontWeight: "bold",
            marginLeft: "8px",
            padding: "4px 8px",
            borderRadius: "6px",
            display: "inline-block",
            backgroundColor: "rgba(255, 0, 0, 0.1)",
            boxShadow: "0 0 10px rgba(255, 0, 0, 0.7)",
          }}
        >
          ⚠️ Expired
        </Typography>
      ) : (
        <Zoom in={daysRemaining > 0 && daysRemaining <= 15} timeout={500}>
          <Typography
            sx={{
              color: "red",
              fontWeight: "bold",
              marginLeft: "8px",
              padding: "4px 8px",
              borderRadius: "6px",
              display: "inline-block",
              backgroundColor: "rgba(255, 0, 0, 0.1)",
              boxShadow: "0 0 10px rgba(255, 0, 0, 0.7)",
              animation: "glowPulse 1.5s infinite alternate ease-in-out",
              "@keyframes glowPulse": {
                "0%": { transform: "scale(1)", boxShadow: "0 0 10px rgba(255, 0, 0, 0.7)" },
                "50%": { transform: "scale(1.1)", boxShadow: "0 0 20px rgba(255, 0, 0, 1)" },
                "100%": { transform: "scale(1)", boxShadow: "0 0 10px rgba(255, 0, 0, 0.7)" },
              },
            }}
          >
            ⚠️ {daysRemaining} days remaining
          </Typography>
        </Zoom>
      )}
    </Typography>
  );
};

export default ExpiryDate;
